import * as React from "react";
import {
    List,
    TopToolbar,
    EditButton,
    SearchInput,
    CreateButton,
    ExportButton,
    Datagrid,
    TextField,
} from "react-admin";


const ListActions = (props) => (
    <TopToolbar>
        <CreateButton />
        <ExportButton />
    </TopToolbar>
);

const CategoryFilters = [<SearchInput  source="category_name" alwaysOn />];


export const CategoryList = (props) => (
    <List {...props} filters={CategoryFilters} actions={<ListActions />} bulkActionButtons={false}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="category_name" />
            <EditButton />
        </Datagrid>
    </List>
);